const chat = {
  // Widget
  title: 'الدعم الفني',
  subtitle: 'كيف يمكننا مساعدتك اليوم؟',
  placeholder: 'اكتب رسالتك...',
  send: 'إرسال',
  close: 'إغلاق المحادثة',
  minimize: 'تصغير',
  expand: 'توسيع المحادثة',
  openChat: 'فتح الدعم الفني',
  powered: 'مدعوم بالذكاء الاصطناعي',
  comingSoon: 'قريباً',

  // Status
  online: 'متصل',
  offline: 'غير متصل',
  typing: 'يكتب...',
  thinking: 'يفكر...',
  connecting: 'جارٍ الاتصال...',

  // Messages
  welcome: 'مرحباً! أنا مساعدك الافتراضي في صفقات 24. كيف يمكنني مساعدتك اليوم؟',
  welcomeOptions: 'يمكنك الاستفسار عن:',
  errorMessage: 'عذراً، حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  emptyMessage: 'يرجى كتابة رسالة',
  connectionError: 'خطأ في الاتصال. يرجى التحقق من اتصال الإنترنت.',

  // Quick actions
  quickActions: {
    title: 'إجراءات سريعة',
    searchProperties: 'البحث عن عقارات',
    viewListings: 'عرض القوائم',
    bookConsultation: 'حجز استشارة',
    contactUs: 'تواصل معنا',
    pricing: 'الأسعار والعضوية',
    help: 'تحتاج مساعدة؟',
  },

  // Topics
  topics: {
    properties: 'العقارات والقوائم',
    pricing: 'معلومات الأسعار',
    consultation: 'حجز استشارة',
    account: 'الحساب والملف الشخصي',
    general: 'أسئلة عامة',
  },

  // AI Responses
  ai: {
    greeting: 'مرحباً بك في صفقات 24! أنا هنا لمساعدتك في العثور على عقارك المثالي.',
    searchHelp: 'يمكنني مساعدتك في البحث عن العقارات. أخبرني ما الذي تبحث عنه - الموقع، نطاق السعر، عدد غرف النوم، أو أي ميزات محددة.',
    propertyTypes: 'لدينا أنواع عقارات متنوعة تشمل الشقق والفلل والاستوديوهات والبنتهاوس. ما النوع الذي يهمك؟',
    priceHelp: 'تتراوح عقاراتنا من الخيارات الاقتصادية إلى الفاخرة. ما هو نطاق السعر المفضل لديك؟',
    locationHelp: 'لدينا عقارات في المدن السعودية الرئيسية بما في ذلك الرياض وجدة والدمام وغيرها. أي منطقة تهمك؟',
    consultationHelp: 'يمكنك حجز استشارة مجانية مع خبراء العقارات لدينا. هل تريد أن أوجهك إلى صفحة الحجز؟',
    contactHelp: 'يمكنك التواصل مع فريقنا عبر البريد الإلكتروني info@safaqat24.sa أو الاتصال على +966 50 560 8271.',
    membershipHelp: 'نقدم خطط عضوية متنوعة مع مزايا حصرية. هل تريد معرفة المزيد؟',
    notUnderstood: 'لست متأكداً أنني فهمت ذلك. هل يمكنك إعادة صياغة سؤالك؟ يمكنك الاستفسار عن العقارات أو الأسعار أو الاستشارات أو الاستفسارات العامة.',
    thankYou: 'شكراً لتواصلك معنا! هل هناك شيء آخر يمكنني مساعدتك به؟',
    goodbye: 'شكراً لمحادثتك معنا. نتمنى لك يوماً سعيداً!',
  },

  // Suggestions
  suggestions: {
    title: 'أسئلة مقترحة',
    searchProperty: 'كيف أبحث عن عقار؟',
    listProperty: 'كيف أضيف عقاري؟',
    consultation: 'كيف أحجز استشارة؟',
    membership: 'ما هي خطط العضوية المتوفرة؟',
    contact: 'كيف أتواصل مع الدعم؟',
    pricing: 'ما هي أسعار الإيجار؟',
  },

  // Feedback
  feedback: {
    helpful: 'هل كان هذا مفيداً؟',
    yes: 'نعم',
    no: 'لا',
    thanks: 'شكراً على ملاحظاتك!',
  },

  // Time
  time: {
    justNow: 'الآن',
    minutesAgo: 'منذ {{count}} دقيقة',
    minutesAgo_plural: 'منذ {{count}} دقائق',
    hoursAgo: 'منذ {{count}} ساعة',
    hoursAgo_plural: 'منذ {{count}} ساعات',
    today: 'اليوم',
    yesterday: 'أمس',
  },
};

export default chat;
